import { issueMessage, Toy, toyError, ToyQuestions, ToyResponse } from './Interface';

export enum ToyTypes {
	LOAD_TOY = 'LOAD/TOYS',
	ERROR_TOY = 'ERROR/TOYS',
	POST_QUESTIONNAIRE = 'POST?QUESTIONNAIRE',
	ISSUE = 'ISSUE?WITH/TOY',
	FETCH_QUESTIONNAIRE = 'FETCH/QUESTIONNAIRE',
	GENERATE_NEW_TOY='GENERATE/NEW/TOY'
}
interface ToyInterface {
	type: typeof ToyTypes.LOAD_TOY;
	payload: {
		data: ToyResponse;
	};
}
interface PostQuestionnaire {
	type: typeof ToyTypes.POST_QUESTIONNAIRE;
	payload: {
		data: ToyQuestions[];
	};
}
interface IssueWithToyInterface {
	type: typeof ToyTypes.ISSUE;
	payload: {
		data: issueMessage
	};
}

interface FetchQuestionarre {
	type: typeof ToyTypes.FETCH_QUESTIONNAIRE;
	payload: {
		data: ToyQuestions[]
	};
}
interface GenerateToy{
	type: typeof ToyTypes.GENERATE_NEW_TOY
}
interface ToyError {
	type: typeof ToyTypes.ERROR_TOY,
	payload: {
		data:toyError
	}
}
export type ToyTypeAction = ToyInterface | PostQuestionnaire | IssueWithToyInterface | FetchQuestionarre | GenerateToy | ToyError;
